/* eslint-disable no-underscore-dangle */
import React from 'react';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import { Icon, Tooltip } from '@/components';
import { useIntl } from 'umi';
import { ShareScreenFull } from '@/models/meeting';
import { chat, members, transcribe } from '@/models';

const FullScreen: React.FC<any> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { meeting } = props;
    const { formatMessage } = useIntl();
    const shareScreenFull = () => {
      if (meeting?.shareScreenFull === ShareScreenFull.FULL) {
        meeting?.setShareScreenFull(ShareScreenFull.INIT);
      } else {
        meeting?.setShareScreenFull(ShareScreenFull.FULL);
        meeting?.peoplePanelShow && meeting?.setPeoplePanelShow(!meeting?.peoplePanelShow);
        chat?.chatVisible && chat?.setChatVisible(!chat?.chatVisible);
        transcribe?.transcribeVisible &&
          transcribe?.setTranscribeVisible(!transcribe?.transcribeVisible);
      }
    };
    return (
      <Tooltip
        title={
          meeting?.shareScreenFull === ShareScreenFull.FULL
            ? formatMessage({ id: 'reduceScreenSize' })
            : formatMessage({ id: 'fullScreenView' })
        }
        className={s.tooltip}
      >
        <span className={s.shareScreenFull} onClick={shareScreenFull}>
          <Icon
            name={meeting?.shareScreenFull === ShareScreenFull.FULL ? 'icon-a-21' : 'icon-a-11'}
            size={20}
            mode="symbol"
            className={s.icon}
          ></Icon>
        </span>
      </Tooltip>
    );
  })
);
export default FullScreen;
